import { DeletePermanentlyModal } from 'components/file-cabinet-folders/modals/delete-permanently-modal/delete-permanently-modal';
import FileViewerModal from 'components/modal/file-viewer-modal';
import { TProjectDeletedFile, useGetShowCabinetFileURLQuery } from 'redux-store/api/file-cabinet';

interface IDeletedActionsModals {
  isDeletingAllItems: boolean;
  isDeletingItem: boolean;
  isDeleteAllFilesModalOpen: boolean;
  fileToDeleteId: number;
  fileToView: TProjectDeletedFile;
  projectId: number;
  clearFileToDeletedId: () => void;
  clearFileToView: () => void;
  closeDeleteAllFilesModal: () => void;
  onConfirmDelete: () => void;
  onConfirmDeleteAllItems: () => void;
}

export const DeletedActionsModals = ({
  isDeletingAllItems,
  isDeletingItem,
  isDeleteAllFilesModalOpen,
  fileToDeleteId,
  fileToView,
  projectId,
  clearFileToDeletedId,
  clearFileToView,
  closeDeleteAllFilesModal,
  onConfirmDelete,
  onConfirmDeleteAllItems,
}: IDeletedActionsModals) => {
  const id = fileToView?.id || null;

  const { data: privateData } = useGetShowCabinetFileURLQuery(
    { fileId: id, projectId: projectId },
    { skip: !id }
  );

  const fileUrl = privateData?.url;

  return (
    <>
      {id ? (
        <FileViewerModal
          path={fileToView?.fileCabinetPath}
          name={fileToView?.name}
          size={fileToView?.size}
          open={!!id}
          handleClose={clearFileToView}
          mimeType={fileToView?.mimeType}
          url={fileUrl}
          fileId={id}
        />
      ) : null}

      {fileToDeleteId ? (
        <DeletePermanentlyModal
          open
          onClose={clearFileToDeletedId}
          onConfirm={onConfirmDelete}
          isLoading={isDeletingItem}
        />
      ) : null}

      {isDeleteAllFilesModalOpen ? (
        <DeletePermanentlyModal
          open
          onClose={closeDeleteAllFilesModal}
          allFiles={true}
          isLoading={isDeletingAllItems}
          onConfirm={onConfirmDeleteAllItems}
        />
      ) : null}
    </>
  );
};
